import React, { MouseEventHandler } from 'react';
import { FiCloudOff, FiRotateCw } from 'react-icons/fi';
import { GENERIC_ERROR_MESSAGE } from '../constants';
import Button from './Button';

type ErrorProps = {
  reload?: MouseEventHandler;
};

const ErrorDisplay = ({ reload }: ErrorProps) => (
  <div className="my-auto self-center flex flex-col items-center">
    <FiCloudOff className="stroke-current text-gray-700 text-3xl" />
    <span className="mt-2 text-gray-700 font-body px-6 text-center whitespace-pre-wrap">
      {GENERIC_ERROR_MESSAGE}
    </span>
    {reload && (
      <Button
        onClick={reload}
        size="md"
        className="mt-4"
        icon={FiRotateCw}
        responsive={false}
      >
        Try again
      </Button>
    )}
  </div>
);

export default ErrorDisplay;
